import { Navigate, Outlet, useLocation } from 'react-router-dom';

import Dashboard from '../pages/Dashboard';
import EditSoapNote from '../pages/SOAPNotes/Admin/SOAPNotes/editSoapNote';
import SOAPNote from '../pages/SOAPNote';
import DataCollection from '../pages/Calendar/Session/DataCollection';
import Client from '../pages/Clients/Client';
import User from '../pages/Users';
import Admin from '../pages/Admins';
import SOAPNotes from '../pages/SOAPNotes';
import Calendar from '../pages/Calendar';
import BCBA from '../pages/BCBA';
import BT from '../pages/BT';
import CS from '../pages/ClinicalSupervisor';
import AddAdmin from '../pages/UserForm/addAdmin';
import UpdateAdmin from '../pages/UserForm/updateAdmin';
import Clients from '../pages/Clients';
import AddClient from '../pages/Clients/ClientForm/addClient';
import UpdateClient from '../pages/Clients/ClientForm/updateClient';
import Assign from '../pages/Clients/AssignTherapists';
import InsuranceAuthorization from '../pages/Clients/Client/InsuranceAuthorization/AllocateInsurance';
import Permissions from '../pages/Permissions';
import AddPermission from '../pages/Permissions/addPermission';
import UpdatePermission from '../pages/Permissions/updatePermission';
import Insurances from '../pages/Insurances';
import AddInsurance from '../pages/Insurances/InsuranceForm/addInsurance';
import UpdateInsurance from '../pages/Insurances/InsuranceForm/updateInsurance';
import NotFound from './notFound';

import API from '../redux/API/Main/API';
import { getToken } from '../redux/API/Main/helpers';
import Reports from '../pages/Reports';

export const Components = [
	// all users
	{ path: 'dashboard', Component: Dashboard },
	{ path: 'calendar', Component: Calendar },
	{ path: 'calendar/session/:sessionId/:clientId', Component: DataCollection },
	{ path: 'clients', Component: Clients },
	{ path: 'clients/client/:clientId', Component: Client },
	{ path: 'soap-notes', Component: SOAPNotes },
	{ path: 'soap-notes/info', Component: SOAPNote },
	{
		path: 'reports',
		Component: Reports,
	},
	// admin
	{ path: 'user', Component: User },
	{ path: 'admin', Component: Admin },
	{ path: 'bcba', Component: BCBA },
	{ path: 'bt', Component: BT },
	{ path: 'cs', Component: CS },
	{ path: 'user/new', Component: AddAdmin },
	{ path: 'admin/new', Component: AddAdmin },
	{ path: 'bcba/new', Component: AddAdmin },
	{ path: 'bt/new', Component: AddAdmin },
	{ path: 'cs/new', Component: AddAdmin },
	{ path: 'user/:userId', Component: UpdateAdmin },
	{ path: 'admin/:userId', Component: UpdateAdmin },
	{ path: 'bcba/:userId', Component: UpdateAdmin },
	{ path: 'bt/:userId', Component: UpdateAdmin },
	{ path: 'cs/:userId', Component: UpdateAdmin },
	{ path: 'clients/new', Component: AddClient },
	{ path: 'clients/:clientId', Component: UpdateClient },
	{ path: 'clients/client/assign/:clientId', Component: Assign },
	{
		path: 'clients/client/allocate-authorization/:clientId',
		Component: InsuranceAuthorization,
	},
	{ path: 'permissions', Component: Permissions },
	{ path: 'permissions/new', Component: AddPermission },
	{ path: 'permissions/:roleId', Component: UpdatePermission },
	{ path: 'insurances', Component: Insurances },
	{ path: 'insurances/new', Component: AddInsurance },
	{ path: 'insurances/edit/:id', Component: UpdateInsurance },
	{ path: 'soap-notes/edit', Component: EditSoapNote },

	{ path: '*', Component: NotFound },
];

const setRedirectURL = (url: string) => window.localStorage.setItem('redirectURL', url);

export const getRedirectURL = () => window.localStorage.getItem('redirectURL');
export const removeRedirectURL = () => window.localStorage.removeItem('redirectURL');

export const ProtectedRoutes = () => {
	const token = getToken();
	const { pathname, search } = useLocation();

	if (!token) {
		setRedirectURL(`${pathname}${search}`);

		return <Navigate to="/login" />;
	}
	const parsedToken = JSON.parse(token);
	API.setToken(parsedToken);

	return <Outlet />;
};

export const LoginChecker = () => {
	const token = getToken();

	if (token) {
		return <Navigate to="/dashboard" />;
	}

	return <Outlet />;
};
